import { useNavigate } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md border border-[var(--line)] bg-white p-10 text-center" data-testid="payment-cancel">
        <XCircle className="w-12 h-12 mx-auto text-[var(--text-2)]" />
        <h2 className="font-serif text-3xl mt-4">Checkout cancelled</h2>
        <p className="text-sm text-[var(--text-2)] mt-2">No charge was made. You can upgrade any time from the dashboard.</p>
        <button
          data-testid="back-to-dashboard"
          onClick={() => navigate("/")}
          className="group mt-6 w-full h-11 bg-[#1A1A18] text-white flex items-center justify-center gap-2 hover:bg-[var(--accent)] transition-colors"
        >
          Back to dashboard <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
    </div>
  );
}
